import localFont from 'next/font/local'

const brandingFont = localFont({
  src: [
    {
      path: '../../public/fonts/branding/branding--bold.woff2',
      weight: '700',
    },
    {
      path: '../../public/fonts/branding/branding--medium.woff2',
      weight: '500',
    },
    {
      path: '../../public/fonts/branding/branding--semibold.woff2',
      weight: '600',
    },
  ],
  style: 'normal',
  variable: '--font-secondary',
})

const generalSansFont = localFont({
  src: [
    {
      path: '../../public/fonts/general-sans/general-sans--medium.woff2',
      weight: '500',
    },
    {
      path: '../../public/fonts/general-sans/general-sans--semi-bold.woff2',
      weight: '600',
    },
  ],
  style: 'normal',
  variable: '--font-primary',
})

const workSansFont = localFont({
  src: [
    {
      path: '../../public/fonts/work-sans/work-sans--bold.woff2',
      weight: '700',
    },
    {
      path: '../../public/fonts/work-sans/work-sans--medium.woff2',
      weight: '500',
    },
    {
      path: '../../public/fonts/work-sans/work-sans--semibold.woff2',
      weight: '600',
    },
  ],
  style: 'normal',
  variable: '--font-primary',
})

const outfitFont = localFont({
  src: [
    {
      path: '../../public/fonts/outfit/outfit--bold.ttf',
      weight: '700',
    },
    {
      path: '../../public/fonts/outfit/outfit--medium.ttf',
      weight: '500',
    },
    {
      path: '../../public/fonts/outfit/outfit--semibold.ttf',
      weight: '600',
    },
  ],
  style: 'normal',
  variable: '--font-secondary',
})

export function getFonts(brandName: string) {
  let primaryFont
  let secondaryFont
  if (brandName === 'eliza') {
    primaryFont = workSansFont
    secondaryFont = outfitFont
  }
  else {
    primaryFont = generalSansFont
    secondaryFont = brandingFont
  }

  return {
    primaryFont,
    secondaryFont,
  }
}
